import TypoGraphy from '@/typography';
import React from 'react';
import './index.scss';
const NoCards = () => {
  return <div className="no_cards_wrapper" data-sentry-component="NoCards" data-sentry-source-file="index.tsx">
        <TypoGraphy text='Please select Different Criteria' variant='Mobile/Body 1' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
    </div>;
};
export default NoCards;